import { motion } from "framer-motion";
import { useState, useEffect } from "react";

const ScrollIndicator = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.div
      className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center"
      initial={{ opacity: 1 }}
      animate={{ opacity: isVisible ? 1 : 0 }}
      transition={{ duration: 0.5 }}
    >
      <span className="text-gray-400 text-sm">Scroll Down</span>
      <motion.div
        className="w-4 h-6 border-2 border-gray-400 rounded-full flex justify-center items-center mt-1"
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 1.5 }}
      >
        <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
      </motion.div>
    </motion.div>
  );
};

export default ScrollIndicator;
